import React from 'react';
import { Skeleton, Stack } from '@mui/material';

function ProfileCardSkeleton() {
  return (
    <>
      <Stack spacing={2.5} direction="column" alignItems="center">
        <Skeleton variant="circular" width={90} height={90} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
      </Stack>
      <Stack spacing={2.5} direction="column" alignItems="center">
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
        <Skeleton variant="rectangular" sx={{ width: '100%' }} height={30} />
      </Stack>
    </>
  );
}

export default ProfileCardSkeleton;
